import React, { Fragment } from "react";
import GeneralMsg from "pages/_components/GeneralMsg";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import * as i18n from "util/i18n";
import Button from "pages/_components/Button";
import { push } from "connected-react-router";
import { useDispatch } from "react-redux";

const Error = () => {
    const dispatch = useDispatch();

    const btnHandlerOnClick = () => {
        dispatch(push("/desktop"));
    };

    const button =  (
        <Button
            className="btn btn-primary btn-block"
            defaultLabelText={i18n.get("global.accept")}
            onClick={btnHandlerOnClick}
            block
        />
    );

    const getContent = () => (
        <MainContainer>
            <div className="above-the-fold">
                <GeneralMsg
                    title={i18n.get("transfers.blacklist.error")}
                    imagePath="figma/illustrations/onboarding14.svg"
                    callToAction={button}
                />
            </div>
        </MainContainer>
    );

    return (
        <Fragment>
            <ResponsiveHeader id="menu.cashout" backLinkTo="/cashOut" />
            <div className="app-page">
                <div className="app-content">
                    <div className="view-wrapper theme-auth">{getContent()}</div>
                </div>
            </div>
        </Fragment>
    );
};

export default Error;
